// extracted by mini-css-extract-plugin
export var fadeInOut = "_1o-3";
export var icon = "_1o-4";
export var savedIndicator = "_1o-2";
export var savingIndicator = "_1o-0";
export var spin = "_1o-1";